import { addQuickCreateCatalog } from '@/redux/modules/quickCreate/catalog/quickCreateCatalog.actions';
import { createSlice } from '@reduxjs/toolkit';
import {
    defaultQuickCreateCatalogSlice,
    QuickCreateCatalogSlice,
} from '@/redux/modules/quickCreate/catalog/quickCreateCatalog.types';

const quickCreateCatalogSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(addQuickCreateCatalog.pending, () => ({
            wasAttempted: false,
        }));
        builder.addCase(addQuickCreateCatalog.fulfilled, (_, { payload }) => ({
            bidderLink: payload.auction,
            catalogId: payload.catalogId,
            mainhostLink: payload.eoaPage,
            wasAttempted: true,
            wasSuccess: true,
        }));
        builder.addCase(addQuickCreateCatalog.rejected, (_, { error }) => ({
            errorMessage: error.message,
            wasAttempted: true,
            wasSuccess: false,
        }));
    },
    initialState: defaultQuickCreateCatalogSlice,
    name: 'quickCreateCatalog',
    reducers: {
        clearLastCreateAttemptResult: (): QuickCreateCatalogSlice => ({
            wasAttempted: false,
        }),
    },
});

export const {
    actions: { clearLastCreateAttemptResult },
    reducer: quickCreateCatalogReducer,
} = quickCreateCatalogSlice;
